import appActions from 'App/duck/actions'
import { allMessagesRead } from 'features/account/inbox/duck/actions'
import {
  deleteCartItemSuccess,
  fetchCartSuccess,
  moveToFavouriteSuccess,
  updateCartItemQuantitySuccess,
} from 'features/cart/cart-overview/duck/actions'
import { ABTestContextSuccess } from 'features/checkout/duck/actions'

const publishedActions = [
  allMessagesRead.getType(),
  fetchCartSuccess.getType(),
  updateCartItemQuantitySuccess.getType(),
  deleteCartItemSuccess.getType(),
  moveToFavouriteSuccess.getType(),
  appActions.changeCustomerType().type,

  // export redux-act actions
  ABTestContextSuccess().type,
]

export default publishedActions
